/* generated by pull.js */
const manifest = {
  "name": "Editor customisable colours",
  "description": "Customise various colours of the AmpMod interface. The default options match those of the default AmpMod theme, while the dark theme can be customised using the \"Default dark\" preset. You can also choose premade presets made by the AmpMod developers.",
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "info": [
    {
      "type": "notice",
      "text": "This addon is a work-in-progress. Not all colours can be customised yet. If you have suggestions, post them on the forums.",
      "id": "workInProgress"
    }
  ],
  "dynamicDisable": true,
  "settings": [
    {
      "dynamic": true,
      "name": "Base theme",
      "id": "base",
      "type": "select",
      "potentialValues": [
        {
          "id": "auto",
          "name": "Auto-detect"
        },
        {
          "id": "light",
          "name": "Light"
        },
        {
          "id": "light-classic",
          "name": "Light (Classic)"
        },
        {
          "id": "dark",
          "name": "Dark"
        }
      ],
      "default": "auto"
    },
    {
      "dynamic": true,
      "name": "Accent",
      "id": "accent",
      "type": "color",
      "default": "#59c059"
    },
    {
      "dynamic": true,
      "name": "Workspace background",
      "id": "workspace",
      "type": "color",
      "default": "#f9f9f9"
    },
    {
      "dynamic": true,
      "name": "Page background",
      "id": "ui",
      "type": "color",
      "default": "#FAFAFA"
    },
    {
      "dynamic": true,
      "name": "Menu bar colour",
      "id": "menubar",
      "type": "color",
      "default": "#ffffff"
    }
  ],
  "tags": [
    "amp",
    "theme",
    "beta",
    "new"
  ],
  "enabledByDefault": false,
  "presets": [
    {
      "name": "Default dark",
      "id": "defaultDark",
      "description": "AmpMod’s built-in dark theme.",
      "values": {
        "base": "dark",
        "accent": "#59c059",
        "workspace": "#1e1e1e",
        "ui": "#111111",
        "menubar": "#59c059"
      }
    },
    {
      "name": "Soft pastel",
      "id": "pastel",
      "description": "A gentle pastel colour theme.",
      "values": {
        "base": "light",
        "accent": "#FFB6C1",
        "workspace": "#FFF8F9",
        "ui": "#FFFDFE",
        "menubar": "#FFFFFF"
      }
    },
    {
      "name": "Fancy dark",
      "id": "fancyDark",
      "description": "Custom theme made by 8to16 on the forums.",
      "values": {
        "base": "dark",
        "accent": "#59c059",
        "workspace": "#241f31",
        "ui": "#3d3846",
        "menubar": "#59c059"
      }
    }
  ]
};
export default manifest;
